import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useGetOngoingAssessmentDetails } from 'src/hooks/meeting.hooks';
import { useMeetingContext } from 'src/context/MeetingProvider';
import AIInterviewNavbar from './AIInterviewNavbar';
import MeetingScreenWrapper from './MeetingScreenWrapper';

type Props = {
	isHost: boolean;
};

const LiveAIInterviewScreen = ({ isHost }: Props) => {
	const { meeting } = useMeetingContext();
	const queryClient = useQueryClient();
	const [joined] = useState(false);

	const { setOngoingAssessDetails, setHasAssessmentEnded, setPredictedUserSalary, setRecommendedUserPath } =
		useMeetingContext();

	const { data: ongoingAssessData } = useGetOngoingAssessmentDetails(meeting?._id, data => {
		setHasAssessmentEnded(data.hasAssessmentEnded ?? false);
		setPredictedUserSalary(data.predictedUserSalary ?? undefined);
		setRecommendedUserPath(data.recommendedUserPath ?? undefined);
	});

	useEffect(() => {
		window.addEventListener('message', e => {
			const data = e.data;
			if (data.type === 'assessment-ended') {
				queryClient.refetchQueries(['getOngoingAssessmentDetails']);
				// setHasAssessmentEnded(data.hasEnded);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (ongoingAssessData?.hasAssessmentEnded) setHasAssessmentEnded(true);
		else if (ongoingAssessData?.ongoingAssess) {
			setOngoingAssessDetails(ongoingAssessData.ongoingAssess);
		} else setOngoingAssessDetails(undefined);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ongoingAssessData]);

	return (
		<>
			<AIInterviewNavbar joined={joined} />
			<div className="mx-5">
				<MeetingScreenWrapper />
			</div>
		</>
	);
};

export default LiveAIInterviewScreen;
